import { Controller } from "react-hook-form";

import {
  ErrorMesageContainer,
  TextFieldContainer,
  FieldContainer,
} from "./styled";
import { TextField, CheckBox, MonthSelector, MonthPeriodSelector } from "..";
import { numberWithCommas, removeNoneNumeric } from "../../utils";

const FormFeild = ({ field, errors, control }) => {
  const hasError = !!errors[field.name];
  const hasRequiredError = hasError && errors[field.name].type === "required";
  const hasInValidError = hasError && !hasRequiredError;
  const requiredErrorMessae = `${field.placeholder} نمی تواند خالی باشد`;
  const inValidErrorMessae = `${field.placeholder} به درستی وارد نشده است`;
  const numberAccept = (value) =>
    !isNaN(Number(value)) && (field.accept ? field.accept(value) : true);
  const accept = field.type === "number" ? numberAccept : field.accept;

  const payload = {
    control,
    rules: {
      ...(field.pattern && { pattern: new RegExp(field.pattern) }),
      required: field.required || false,
    },
    name: field.name,
    placeholder: hasRequiredError ? requiredErrorMessae : "",
    className: field.className || "",
    error: hasError,
  };
  switch (field.type) {
    case "text":
    case "number":
      function handleChange(e, onChange) {
        if (field.type === "number") {
          e.target.value = removeNoneNumeric(e.target.value);
        }
        if (accept) {
          if (accept(e?.target?.value)) {
            onChange(e);
          }
        } else {
          onChange(e);
        }
      }
      return (
        <FieldContainer className={field.className}>
          <h6 className="subtitle">{field.placeholder}</h6>
          <TextFieldContainer>
            <Controller
              render={({ onChange, value }) => (
                <TextField
                  inputMode={field.type === "number" ? "numeric" : "text"}
                  {...payload}
                  value={
                    field.seprateWithCommas ? numberWithCommas(value) : value
                  }
                  onChange={(e) => handleChange(e, onChange)}
                  style={{
                    direction:
                      field.type === "number" && !payload.placeholder
                        ? "ltr"
                        : "rtl",
                  }}
                />
              )}
              {...payload}
              defaultValue=""
            />
            {field.adornment && (
              <label htmlFor={field.name}>{field.adornment}</label>
            )}
          </TextFieldContainer>
          {hasInValidError && (
            <ErrorMesageContainer className={field.className || ""}>
              {inValidErrorMessae}
            </ErrorMesageContainer>
          )}
        </FieldContainer>
      );
    case "checkbox":
      return (
        <FieldContainer className={field.className}>
          <Controller
            as={CheckBox}
            {...payload}
            rules={undefined}
            defaultValue={false}
            onChange={() => {}}
            placeholder={field.placeholder}
          />
        </FieldContainer>
      );

    case "month":
      return (
        <FieldContainer className={field.className}>
          <Controller
            render={({ onChange, value }) => (
              <MonthSelector
                {...payload}
                value={value}
                onChange={(e) => handleChange(e, onChange)}
                placeholder={field.placeholder}
              />
            )}
            {...payload}
          />
        </FieldContainer>
      );
    case "monthPeriod":
      return (
        <FieldContainer className={field.className}>
          <Controller
            defaultValue=""
            render={({ onChange }) => (
              <MonthPeriodSelector
                {...payload}
                onChange={(e) => handleChange(e, onChange)}
              />
            )}
            {...payload}
          />
          {hasRequiredError && (
            <ErrorMesageContainer>{requiredErrorMessae}</ErrorMesageContainer>
          )}
        </FieldContainer>
      );
    default:
      return null;
  }
};

export default FormFeild;
